document.querySelector("select[id^=employee_title]")?.addEventListener('change', function(e) {
    var selection = e.target.value;
    var otherTitleInput = document.getElementById("other_title_input");
    var employeeOtherTitle = document.getElementById("employee_other_title");
    if (selection == "Other...") {
        if (otherTitleInput) otherTitleInput.style.display = otherTitleInput.style.display === "none" ? "block" : "none";
    } else {
        if (employeeOtherTitle) employeeOtherTitle.value = "";
        if (otherTitleInput) {
            otherTitleInput.style.display = "none";
        }
    }
});

document.querySelector("select[id=employee_staff_level]")?.addEventListener('change', function(e) {
    var selection = e.target.value;
    var checkbox = document.querySelector(`input[type=checkbox][value="${selection}"]`);
    if (checkbox) checkbox.checked = true;
});

document.querySelectorAll("input[id^=employee_computer]").forEach(function(input) {
    input.addEventListener('change', function(e) {
        var selection = e.target.value;
        var carryingCaseInput = document.getElementById("employee_carrying_case_input");
        if (selection.includes("Desktop")) {
            if (carryingCaseInput) carryingCaseInput.style.display = "none";
            document.querySelectorAll("[name='employee[carrying_case]']").forEach(function(v) {
                v.checked = false;
            });
        } else {
            if (carryingCaseInput) carryingCaseInput.style.display = "block";
        }
        if (selection.includes("Lenovo P")) {
            document.querySelectorAll("input[type=checkbox][value^=Lenovo]").forEach(function(cb) {
                cb.checked = true;
            });
        }
    });
});

document.getElementById("onboarding-2")?.addEventListener("submit", function(e) {
  var initials = document.getElementById("employee_initials");
  var approver = document.getElementById("employee_timesheet_approver");
  let valid = true;

  if (initials && initials.value.length !== 3) {
    alert("Employee initials must be exactly 3 characters.");
    valid = false;
  }

  if (approver && approver.value === '') {
    alert("Employee timesheet approver is required.");
    valid = false;
  }

  if (!valid) {
    console.log("Form validation failed.");
    console.log(e.target)
    setTimeout(() => {
      const submitBtn = e.target.querySelector("[type=submit]");
      if (submitBtn) submitBtn.disabled = false;
    }, 500);
    e.preventDefault();
  }
});
